/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_CollusionInputs */



/**
* | output |
* | --- |
* | "Collusion" |
*
* @param {Sanction_Sub_CollusionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_collusion = /** @type {((inputs?: Sanction_Sub_CollusionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_CollusionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Collusion")
	if (locale === "es") return /** @type {LocalizedString} */ ("Colusión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Conluio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collusione")
	return /** @type {LocalizedString} */ ("Collusion")
});